import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import { ReactComponent as LinkLeftIcon } from "../../../../icons/icon_files/Direction_link_left_16.svg";
import SvgToIcon from "../../../../icons/SvgToIcon";

export default function IntegrationTypeBackButton({ name }) {
  const colors = useColors();
  const { trackEvent } = useAPI();
  const navigate = useNavigate();

  const handleBackButtonClick = () => {
    trackEvent(
      "User clicked the back button to the integrations page from " + name
    );
    navigate("/inventory/integrations");
  };

  return (
    <Box
      height="24px"
      width="max-content"
      display="flex"
      alignItems="center"
      onClick={handleBackButtonClick}
      sx={{ cursor: "pointer" }}
    >
      <SvgToIcon IconLogo={LinkLeftIcon} width="18px" />
      <Typography variant="overline" color={colors.grey_700}>
        Back to Integrations
      </Typography>
    </Box>
  );
}
